unable to read source [project]/packages/core/src/runtime/reduceToClassNameForSlots.ts